ixModuleRouting("impactx.reLoginExternal", {
    "/relogin.external": {
        controller: "ReloginExternalCtrl",
        template: "<ixa-relogin-external></ixa-relogin-external>",
        templateUrl: "modules/reloginexternal/templates/relogin.external.html",
        workspace: "shop",
        noSecurity: true,
    },
});
